<template>
    <div class="row occupation-files-content">
        <div class="col-12">
            <UploadMultipleFile
                :disabled="readonlyForm"
                v-model="form"
                :acceptTypes="acceptTypes"
                :maxFiles="maxFiles"
                name="occupation-files"
                keyFile="file"
                pathProperty="url"
                filenameProperty="filename"
                :extraNewProperties="newFileProperties"
                :data-vv-scope="vScope"
                v-validate="''"
            />
        </div>
    </div>
</template>

<script>
import FormElementMixin from "../mixins/FormElementMixin";

export default {
    mixins: [FormElementMixin],
    components: {
        UploadMultipleFile: () => import(/* webpackChunkName: "upload-file" */ "@/components/form/UploadMultipleFile")
    },
    props: {
        value: {
            type: Array,
            default: () => {
                return [];
            }
        }
    },
    data() {
        return {
            form: []
        };
    },
    computed: {
        filesCfg() {
            return this.panelCfg?.panel?.files ?? {};
        },
        maxFiles() {
            return this.filesCfg?.maxFiles ?? 3;
        },
        acceptTypes() {
            return (this.filesCfg?.mimeTypes ?? ["*"]).join(", ");
        },
        filesNewCfg() {
            return this.filesCfg?.new ?? {};
        },
        newFileProperties() {
            return this.filesNewCfg?.properties ?? {};
        }
    },
    methods: {}
};
</script>

<style lang="scss" scoped></style>
